export default __webpack_public_path__ + "static/media/Armguards of the Usurper.c2e65d25.jpg";